if (window.matchMedia("(max-width: 991px)").matches) {
    var elem = document.querySelector('.slider_mobile');
    var flkty = new Flickity( elem, {
      // options
      cellAlign: 'center',
      contain: true,
      wrapAround: false,
      prevNextButtons: false,
      imagesLoaded: true,
      adaptiveHeight: true,
      pageDots: true,
    });
};